import React from "react";
import Icon from "components/AppIcon";

const StatItem = ({ icon, label, value, subValue, color, iconBg }) => (
  <div
    className="flex items-center gap-3 p-3 md:p-4 rounded-xl border border-border"
    style={{ background: "var(--color-card)" }}
  >
    <div
      className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
      style={{ background: iconBg || "rgba(0,217,255,0.1)" }}
    >
      <Icon name={icon} size={18} color={color || "var(--color-primary)"} />
    </div>
    <div className="min-w-0">
      <p className="font-caption text-xs text-muted-foreground truncate">{label}</p>
      <p className="font-heading text-sm md:text-base font-bold text-foreground whitespace-nowrap">
        {value}
      </p>
      {subValue && (
        <p className="font-caption text-xs text-muted-foreground truncate">{subValue}</p>
      )}
    </div>
  </div>
);

const StatsRow = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <StatItem
        icon="TrendingUp"
        label="Total Trades"
        value={stats?.totalTrades?.toLocaleString()}
        subValue="All time"
        color="var(--color-primary)"
        iconBg="rgba(0,217,255,0.1)"
      />
      <StatItem
        icon="Building2"
        label="Businesses"
        value={stats?.businesses}
        subValue={`$${stats?.businessRevenue?.toLocaleString()}/tick`}
        color="var(--color-accent)"
        iconBg="rgba(255,184,0,0.1)"
      />
      <StatItem
        icon="Skull"
        label="Crimes"
        value={`${stats?.crimeSuccessRate}%`}
        subValue={`${stats?.crimesCompleted} completed`}
        color="var(--color-error)"
        iconBg="rgba(239,68,68,0.1)"
      />
      <StatItem
        icon="Trophy"
        label="Global Rank"
        value={`#${stats?.globalRank?.toLocaleString()}`}
        subValue="Net worth"
        color="var(--color-success)"
        iconBg="rgba(16,185,129,0.1)"
      />
    </div>
  );
};

export default StatsRow;